// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2197":"31d6cfe0","4512":"2e74954f","5310":"3c3efda5"}[chunkId] + ".chunk.css";
};